angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-report-service',
        function ($api, $service) {
            $api.factory.report = $service;
        },
    ])
    .service('contest.service', [
        'graph-api-client',
        function ($api) {
            this.retrieve = function (codeName, options) {
                return $api.get(['contest', codeName], options);
            };

            this.execute = function (codeName, contestForm, options) {
                return $api.post(['contest', codeName], contestForm, options);
            };
        },
    ])
    .controller('contest-modal.controller', [
        '$scope',
        'contest.service',
        function ($scope, $service) {
            $scope.opened = false;

            $scope.contestForm = { account_id: '0' };
            $scope.contestError = {};

            $scope.options = [];
            $scope.contestName = '';
            $scope.alreadyThere = false;
            $scope.loading = false;

            $scope.$on('open:contest:dialog', function (event, data) {
                $scope.opened = true;
                $scope.contestName = data.contestName;
                $scope.loading = true;

                $service.retrieve($scope.contestName).then(function (response) {
                    if (response.data.state === 0) {
                        $scope.options = response.data.data;
                    } else if (response.data.state === 11) {
                        $scope.alreadyThere = true;
                    }

                    if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                        $scope.$apply();
                    }

                    $scope.loading = false;
                });
            });

            $scope.closeDialog = function () {
                $scope.opened = false;
            };

            $scope.onSubmit = function (contestForm) {
                $scope.contestError = {};

                $service.execute($scope.contestName, $scope.contestForm).then(function (response) {
                    if (response.data.state === 0) {
                        $scope.closeDialog();
                    } else {
                        $scope.contestError = response.data.data;
                    }
                });
            };
        },
    ]);
